import { Navigate } from 'react-router-dom';
import Page404 from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Page404';
import Page500 from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Page500';
import theme from '@monorepo/shared/src/themes/defaultTheme';
import { RouteConfig } from '@monorepo/shared/src/types';
import EditTeachingOrder from 'components/modules/EditTeachingOrder';
import HelpAndSupport from 'components/modules/HelpAndSupport';
import HelpAndSupportResources from 'components/modules/HelpAndSupport/components/HelpAndSupportResources';
import Activities from 'components/modules/Activities';
import AssignLetter from 'components/modules/AssignLetter';
import Assignments from 'components/modules/Assignments';
import EditAssignment from 'components/modules/EditAssignment';
import LetterBooks from 'components/modules/LetterBooks';
import LetterTeachingTabView from 'components/modules/LetterTeachingTabView';
import SelectFindItActivities from 'components/modules/SelectFindItActivities';
import Home from 'components/modules/Home';
import PracticeBook from 'components/modules/PracticeBook';
import Preferences from 'components/modules/Preferences';
import Resources from 'components/modules/Resources';
import TeachersGuide from 'components/modules/TeachersGuide';
import OnboardingTour from 'components/modules/Tours/Onboarding';
import Reports from 'components/modules/Reports';
import Sandbox from 'components/layout/Sandbox';
import ProfessionalLearning from 'components/modules/ProfessionalLearning';
import { isQA } from '@monorepo/shared/src/config';

export const routes: RouteConfig[] = [
  {
    path: '/404',
    component: Page404 as any,
    defaultComponentProps: { theme: theme.palette.secondary.dark },
    isPrivate: false,
    backgroundColor: '#F4F4F4',
    getTitle: () => '404 Not Found',
  },
  {
    path: '/oops',
    component: Page500 as any,
    defaultComponentProps: { theme: theme.palette.secondary.dark },
    isPrivate: false,
    backgroundColor: '#F4F4F4',
    getTitle: () => '500 Internal Server Error',
  },
  {
    path: '/',
    component: Navigate,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Home',
    to: '/home',
    replace: true,
  },
  {
    path: 'home',
    component: Home,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Home',
  },
  {
    path: '/edit-teaching-order',
    component: EditTeachingOrder,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Edit Teaching Order',
  },
  {
    path: '/letter-teaching/:letter/:tab',
    component: LetterTeachingTabView,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Letter Teaching',
  },
  {
    path: '/activity-selection/:letter',
    component: SelectFindItActivities,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Activity Selection',
  },
  {
    path: '/assignments',
    component: Assignments,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Assignments',
  },
  {
    path: '/assignments/:letter',
    component: AssignLetter,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Assign Letter',
  },
  {
    path: '/assignments/edit/:letter',
    component: EditAssignment,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Edit Assignments',
  },
  {
    path: '/student-practice-book',
    component: PracticeBook,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Student Practice Book',
  },
  {
    path: '/teachers-guide',
    component: TeachersGuide,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => "Teacher's Guide",
  },
  {
    path: '/letter-books',
    component: LetterBooks,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Letter Books',
  },
  {
    path: '/letter-books/:bookCode',
    component: LetterBooks,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Letter Books',
  },
  {
    path: '/classroom-books',
    component: LetterBooks,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Student Books',
  },
  {
    path: '/classroom-books/:bookCode',
    component: LetterBooks,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Student Books',
  },
  { path: '/tour/onboarding', component: OnboardingTour, isPrivate: true, getTitle: () => 'Tour' },
  {
    path: '/resources',
    component: Resources,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Resources',
  },
  {
    path: '/resources/pinned-resources',
    component: Resources,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Pinned Resources',
  },
  {
    path: '/:character/activities/:activityType',
    component: Activities,
    isPrivate: true,
    backgroundColor: '#FCF7F2',
    getTitle: () => 'Activities',
  },
  {
    path: '/preferences',
    component: Preferences,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Preferences',
  },
  {
    path: '/help-and-support',
    component: HelpAndSupport,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Help & Support',
  },
  {
    path: `/help-and-support/:supportResourceType`,
    component: HelpAndSupportResources,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Support Resources',
  },
  {
    path: '/reports',
    component: Reports,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Student Reporting',
  },
  {
    path: '/professional-learning',
    component: ProfessionalLearning,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Preferences & Class Settings',
  },
  {
    path: '*',
    component: Navigate,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Home',
    to: '/home',
    replace: true,
  },

  ...(isQA(process.env.REACT_APP_BUILD_ENV as string)
    ? [
        {
          getTitle: () => 'Sandbox',
          path: '/sandbox',
          component: Sandbox,
          isPrivate: true,
        },
      ]
    : []),
];
